import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "SEO puts your site in front of people actively searching for what you offer. We combine technical fixes, on-page optimisation and content strategy to grow qualified organic traffic that compounds over time.",
    "Every engagement starts with an audit and clear goals, then focuses on the changes that actually move rankings and conversions — not vanity metrics.",
];

const FEATURES = [
    { title: "Technical SEO", text: "Speed, crawlability, structure and Core Web Vitals fixed at the foundation." },
    { title: "On-page optimisation", text: "Titles, content, internal links and schema tuned for the terms that matter." },
    { title: "Content strategy", text: "Genuinely useful content mapped to real search intent and your funnel." },
    { title: "Reporting that matters", text: "Clear tracking of rankings, traffic and conversions — no fluff." },
];

const CHECKS = [
    "Get more targeted traffic",
    "Improve conversion rates",
    "Technical & on-page SEO",
    "Keyword & content strategy",
    "Ongoing optimisation & reporting",
];

export default function Seo() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Digital Marketing" title="Search Engine Optimisation" eyebrowAs="span">
                    Get found by the people already looking for you — technical, on-page and content SEO that earns durable, targeted traffic.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
